import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import _ from 'lodash';

const propTypes = {
  taxrate: PropTypes.any,
  taxrates: PropTypes.any,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
};

class EditTaxrate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        tax: null,
      },
      taxrate: {
        name: null,
        zipcode: null,
        tax: 0,
        disabled: false,
      },
      open: false,
      edited: false,
      viewRedirect: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let taxrate = nextProps.taxrate;
    if (nextProps.taxrate.zipcode) {
      taxrate = nextProps.taxrate;
    } else {
      taxrate = nextProps.taxrates.results[0];
    }
    taxrate.zipcode = (taxrate.zipcode === null) ? 0 : taxrate.zipcode;
    this.setState({ taxrate });
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const taxrate = this.state.taxrate;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = taxrate[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleDeleteOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Delete Tax Rate';
    nextState.dialogMessage = 'Do you really want to delete this tax rate?';
    nextState.dialogActionTitle = 'Delete';
    nextState.open = true;
    nextState.delete = true;
    this.setState({ nextState });
  }
  handleChange(e) {
    const taxrate = this.props.taxrate;
    if (e.target.type === 'checkbox') {
      _.set(taxrate, e.target.name, e.target.checked);
    } else {
      _.set(taxrate, e.target.name, e.target.value);
    }
    this.setState({
      taxrate,
      edited: true,
    });
    this.setRequiredParams();
  }
  navigateToView() {
    if (this.state.edited === true) {
      const nextState = this.state;
      nextState.viewRedirect = true;
      this.setState(nextState);
      this.handleOpen();
    } else {
      browserHistory.push(`/taxrate/view/${this.state.taxrate.zipcode}`);
    }
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      browserHistory.push(`/taxrate/view/${this.state.taxrate.zipcode}`);
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Tax Rate Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this tax rate?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.props.taxrate.id);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(this.state.taxrate);
        break;
      default:
        this.props.onSave(this.state.taxrate);
        break;
    }
  }
  handleCancel() {
    browserHistory.push('/taxrate?page=1');
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div>
        <div>
          <DialogModal
            dialogOpen={this.state.open}
            dialogHandleClose={this.handleClose}
            dialogHandleSubmit={() => this.saveChanges()}
            dialogTitle={this.state.dialogTitle}
            dialogMessage={this.state.dialogMessage}
            dialogActionTitle={this.state.dialogActionTitle}
          />
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ marginRight: '10px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="View"
              primary
              onClick={this.navigateToView}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="Delete"
              primary
              onClick={this.handleDeleteOpen}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleOpen}
            />
          </div>
          <br />
          <TextField
            floatingLabelText="Zipcode"
            floatingLabelStyle={styles.floatingLabelStyle}
            inputStyle={styles.inputStyle}
            value={this.props.taxrate.zipcode}
            disabled
          />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.taxrate.name || ''}
            name="name"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Tax Rate"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.taxrate.tax || ''}
            name="tax"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.tax}
            errorStyle={{ color: cyan500 }}
          />
        </div>
      </div>
    );
  }
}

EditTaxrate.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditTaxrate.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    taxrate: state.taxrates.taxrate,
    taxrates: state.taxrates,
  };
}

export default connect(mapStateToProps)(EditTaxrate);



// WEBPACK FOOTER //
// ./src/components/taxrate/EditTaxrate.js